import { SupportPermissions } from "@redotech/account-common/permissions";
import { RedoSecondaryNavItem } from "@redotech/arbiter/navigation/secondary/redo-secondary-nav-item";
import { useRequiredContext } from "@redotech/react-util/context";
import { useTranslation } from "@redotech/redo-i18n";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { useCapability } from "@redotech/redo-merchant-app-common/use-capability";
import BarChart10FilledIcon from "@redotech/redo-web/icon-old/bar-chart-10-filled.svg";
import BarChart10Icon from "@redotech/redo-web/icon-old/bar-chart-10.svg";
import { memo } from "react";
import { useMatch } from "react-router-dom";

export const SupportAnalyticsItems = memo(function SupportAnalyticsItems() {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);
  const team = useRequiredContext(TeamContext);
  const supportEnabled = useCapability("support");

  const canViewSupportAnalytics = useHasPermission(
    SupportPermissions.VIEW_ANALYTICS,
  );
  const showSupportAnalytics = supportEnabled && canViewSupportAnalytics;

  const aiEnabled = !!team?.settings.support?.ai?.enabled;

  const analyticsPageRoute = routes.supportBaseUrl + "/analytics";
  const analyticsRoute = routes.legacySupportBaseUrl + "/analytics";
  const legacyAiDashboardRoute = routes.legacySupportBaseUrl + "/dashboard";
  const aiDashboardRoute = routes.supportBaseUrl + "/dashboard";
  const analyticsPageMatch = useMatch(`${analyticsPageRoute}/*`);
  const analyticsRouteMatch = useMatch(`${analyticsRoute}/*`);
  const legacyAiDashboardRouteMatch = useMatch(`${legacyAiDashboardRoute}/*`);
  const aiDashboardRouteMatch = useMatch(`${aiDashboardRoute}/*`);
  const anyChildSelected =
    analyticsPageMatch ||
    analyticsRouteMatch ||
    legacyAiDashboardRouteMatch ||
    aiDashboardRouteMatch;

  const showAiDashboard = aiEnabled;

  const shouldRenderAnalytics = showSupportAnalytics || showAiDashboard;

  if (!shouldRenderAnalytics) {
    return null;
  }

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: analyticsPageRoute }}
      anyChildSelected={!!anyChildSelected}
      FilledIcon={BarChart10FilledIcon}
      friendlyName={t("Analytics", {
        context: "customer support navigation label",
      })}
      id="support-analytics"
      UnfilledIcon={BarChart10Icon}
    />
  );
});
